import axios from '@/axiosInterceptor';

const state = () => ({
  searchResults: [],
  showVehicle: undefined,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
  },
  filters: {},
});

// getters
const getters = {};

// actions
const actions = {
  async searchVehicles({ commit }, { page = 1, perPage = 50, filters }) {
    try {
      const queryParams = {
        page,
        per_page: perPage,
        'q[s]': 'date desc',
      };

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          queryParams[`q[${key}]`] = value;
        });
      }

      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/carrier_vehicles`,
        {
          params: queryParams,
        }
      );
      commit('setVehiclesSearchResults', res);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  async loadShowVehicle({ commit }, { id }) {
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/vehicles/${id}`
      );
      commit('setShowVehicle', res.data);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async searchVehicleByVin({ commit }, vin) {
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/vehicles/${vin}/by_vin`
      );
      commit('setShowVehicle', res.data);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

const mutations = {
  setSearchFilters: function (state, filters) {
    state.filters = filters;
  },
  setVehiclesSearchResults: function (state, res) {
    state.searchResults = res.data;
    const headers = res.headers;
    state.pagination = {
      currentPage: parseInt(headers.currentpage),
      totalPages: parseInt(headers.totalpages),
      totalRecords: parseInt(headers.totalitems),
    };
  },
  clearSearchResults: function (state) {
    state.searchResults = [];
    state.pagination = {
      currentPage: 1,
      totalPages: 1,
      totalRecords: 0,
    };
  },
  resetStore: function () {},
  setShowVehicle: function (state, vehicle) {
    state.showVehicle = vehicle;
  },
  clearShowVehicle: function (state) {
    state.showVehicle = undefined;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
